var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advance-imgTxt-four--container",style:(_vm.containerConfigStyle)},_vm._l((Math.ceil(_vm.cardList.length/_vm.rowsNum)),function(groupIndex){return _c('div',{key:groupIndex,staticClass:"card-container--row",style:({
      paddingBottom: `${_vm.verticalGutter}px`,
      maxWidth: _vm.maxWidth,
      margin: '0 auto'
    })},_vm._l((_vm.cardList.slice((groupIndex-1)*_vm.rowsNum, groupIndex*_vm.rowsNum)),function(item,index){return _c('div',{key:`${groupIndex}_${index}`,staticClass:"card-container--col",class:{
        'hover-animation': _vm.imageConfig.hoverAnimation,
        'is-click': !!item.link
      },style:({
        marginRight: `${_vm.gutter}px`,
        width: _vm.colWidth,
      })},[_c('card-container',{attrs:{"cardData":item,"cardConfig":_vm.cardConfig,"imageConfig":_vm.imageConfig,"textConfig":_vm.textConfig,"layout":_vm.layout},on:{"click":function($event){_vm.handleClick(((groupIndex - 1) * _vm.rowsNum) + index, item)}}})],1)}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }